// Utility function to determine media type
export const getMediaType = (
  fileName: string,
): 'image' | 'video' | 'unknown' => {
  const extension = fileName.split('.').pop()?.toLowerCase();

  if (!extension) {
    return 'unknown';
  }

  const videoExtensions = ['mp4', 'webm', 'ogg', 'mov', 'avi'];
  const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg'];

  if (videoExtensions.includes(extension)) {
    return 'video';
  }
  if (imageExtensions.includes(extension)) {
    return 'image';
  }

  return 'unknown';
};
